module.exports = __webpack_public_path__ + "img/Home.2fa9b829.svg";